import { Modal } from 'bootstrap';
import randomGenerator from '../modules/random-generator';
import passwordVisibility from '../modules/password-visibility';
import placeholder from '../modules/placeholder';
import initAliasDeleteModal from '../modules/alias-delete-modal';
import initForwardDeleteModal from '../modules/forward-delete-modal';

const initialize = () => {
    placeholder('eu-temp');
    randomGenerator();
    passwordVisibility();
    initAliasDeleteModal();
    initForwardDeleteModal();

    const pop3PremiumEnableBtn = document.getElementById('pop3-premium-enable-btn');
    if (pop3PremiumEnableBtn) {
        pop3PremiumEnableBtn.addEventListener('click', () => {
            document.getElementById('status').value = 'open';
            document.getElementById('pop3-enable-btn').click();
        });
    }

    const pop3PasswordEl = document.getElementById('pop3PasswordModal');
    if (pop3PasswordEl) {
        const pop3PasswordModal = new Modal(pop3PasswordEl, {
            focus: false
        });
        pop3PasswordModal.hide();
    }

    const pop3EnableBtn = document.getElementById('pop3-enable-btn');
    if (pop3EnableBtn) {
        pop3EnableBtn.addEventListener('click', () => {
            if (!pop3EnableBtn.checked) {
                return;
            }

            // if set trial
            if (['trial', 'closed'].includes(document.getElementById('status').value)) {
                // if set trial and no premium left show buy quot window
                // if set trial and has premium show switch to premium confirmation window
                pop3EnableBtn.setAttribute('data-bs-toggle', 'modal');
                pop3EnableBtn.setAttribute('data-bs-target', '#pop3PremiumEnableModal');
                pop3EnableBtn.checked = false;

                const pop3PremiumEnableModal = new Modal(document.getElementById('pop3PremiumEnableModal'));
                if (!pop3PremiumEnableModal) {
                    return;
                }
                pop3PremiumEnableModal.show();
                return;
            }
            pop3EnableBtn.classList.remove('purchase-more');
            pop3EnableBtn.setAttribute('data-bs-toggle', '');
        });
    }

    const emailClientSettingsEl = document.getElementById('email-client-settings');
    if (emailClientSettingsEl) {
        emailClientSettingsEl.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            window.open(emailClientSettingsEl.getAttribute('href'), '_blank').focus();
        });
    }
};

export default initialize;
